function parseSKU(sku) {
  // Handle null or empty SKUs
  if (!sku) {
    console.warn('Empty or null SKU passed to parseSKU');
    return { size: 0, color: '' };
  }

  try {
    // For watches: NR32GOLEBLXX format
    // For straps: ST16BRGOMEGO format

    let size, color;

    if (
      sku.startsWith('NR') ||
      sku.startsWith('PI') ||
      sku.startsWith('PH') ||
      sku.startsWith('GU') ||
      sku.startsWith('UN') ||
      sku.startsWith('AL')
    ) {
      // Watch parsing: Size at position 2-3 (0-indexed), Color at position 4-5
      size = parseInt(sku.slice(2, 4), 10);
      color = sku.slice(4, 6);
    } else if (sku.startsWith('ST')) {
      // Strap parsing: Size at position 2-3, Color at position 6-7 (not 4-5)
      size = parseInt(sku.slice(2, 4), 10);
      color = sku.slice(6, 8);
    } else {
      // Unknown format, try default parsing
      size = parseInt(sku.slice(2, 4), 10);
      color = sku.slice(4, 6);
    }

    // Debug
    console.log(`Parsed SKU ${sku}: size=${size}, color=${color}`);

    return { size, color };
  } catch (error) {
    console.error('Error parsing SKU:', sku, error);
    return { size: 0, color: '' };
  }
}

function isCompatible(watchSKU, strapSKU) {
  // Handle null or empty SKUs
  if (!watchSKU || !strapSKU) {
    console.warn('Empty or null SKU passed to isCompatible:', { watchSKU, strapSKU });
    return false;
  }

  // Exclude GU and SN watches from matching any strap
  const excludedPrefixes = ['GU', 'SN', "AL"];
  const watchPrefix = watchSKU.slice(0, 2).toUpperCase();
  if (excludedPrefixes.includes(watchPrefix)) {
    console.log(`Watch SKU ${watchSKU} is excluded from strap matching.`);
    return false;
  }

  try {
    const watch = parseSKU(watchSKU);
    const strap = parseSKU(strapSKU);

    // Size compatibility: Watch size = Strap size * 2
    const sizeCompatible =
      watch.size === strap.size * 2 ||
      // Special case for 40mm and 42mm watches which can use 20mm straps
      ((watch.size === 40 || watch.size === 42) && strap.size === 20);

    // Color compatibility: Watch color = Strap color
    const colorCompatible = watch.color.toUpperCase() === strap.color.toUpperCase();

    // Debug
    console.log(
      `Compatibility check: ${watchSKU} (${watch.size}/${watch.color}) with ${strapSKU} (${strap.size}/${strap.color}) -> Size: ${sizeCompatible}, Color: ${colorCompatible}`
    );

    return sizeCompatible && colorCompatible;
  } catch (error) {
    console.error('Error checking compatibility:', error, { watchSKU, strapSKU });
    return false;
  }
}
